

export const DataCardServices = [
    {
        id:1,
        title:'Gestiones contables.',
        description:'Estamos contigo desde la constitución de tu sociedad.',
        href:'',      
    },
    {
        id:2,
        title:'Procesos operacionales.',
        description:'Calidad de servicio, tenemos los mejores profesionales.',
        href:'',      
    },
    {
        id:3,
        title:'Proceso de remuneraciones.',
        description:'Ciclo completo, liquidaciones mensuales, pagos de cotizaciones previsionales, retenciones, emisión LRE e informes por trabajador, ingreso DT.',
        href:'',      
    },
    {
        id:4,
        title:'Servicios legales.',
        description:'Administradores públicos, abogados dispuestos en asesorarte.',
        href:'',      
    },
    // {
    //     id:5,
    //     title:'Administración.',
    //     description:'Empresas en general',
    //     href:'',      
    // },
    {
        id:5,
        title:'Servicios digitalización y facturación.',
        description:'Organizacion, ejecucion y digitalización para automatizar tu tiempo.',
        href:'',      
    },
    {
        id:6,
        title:'Conciliación bancaria-pericias contables.',
        description:'Tendrás el control y supervisión de tus finanzas.',
        href:'',      
    }
]